<script setup lang="ts">
// @ts-nocheck TODO: 既存の型エラーを解消したら外す
import { storeToRefs } from 'pinia'

import Icon from '@/client/components/_atoms/basic_icon'
import { useNavbarStore } from '@/client/store/useNavbarStore'

import BreadcrumbName from './BreadcrumbName.vue'

const navbarStore = useNavbarStore()
const { breadcrumbs } = storeToRefs(navbarStore)
</script>

<template>
  <div class="breadcrumb-container">
    <div class="breadcrumb-flex" v-for="(breadcrumb, index) in breadcrumbs" :key="index">
      <div v-if="index > 0">
        <i class="mdi mdi-chevron-double-right" />
      </div>
      <el-tooltip v-if="breadcrumb.isIcon" :content="breadcrumb.iconName" placement="bottom">
        <Icon class="icon" :picture-url="breadcrumb.iconUrl" :icon-type="breadcrumb.iconType" />
      </el-tooltip>
      <BreadcrumbName :name="breadcrumb.name" :link="breadcrumb.link" />
      <div v-if="breadcrumb.label" class="badge badge-danger">
        {{ breadcrumb.label }}
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use '@/client/assets/scss/variables.scss' as *;

.breadcrumb-container {
  display: flex;
  gap: $spacing-unit;
  align-items: center;
}

.breadcrumb-flex {
  display: flex;
  gap: $spacing-unit;
  align-items: center;
}

// badgeの共通クラスがposition: absolute;になっているため
:deep(.badge) {
  position: relative;
}
</style>
